import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { RecoilRoot } from 'recoil';
import { SavedProjectConfigurationsListPage } from 'pages/saved-project-configurations-list';
import { Fallback } from 'pages/fallback/fallback';
import { initI18n } from 'utils/init-i18n';
import { ErrorBoundary } from '../../error-boundary';
import { TData } from './context';

export type SavedProjectConfigurationsListProps = TData;
export type SavedProjectConfigurationsListState = TData;

export const SavedProjectConfigurationsList: React.FC<TData> = data => {
  initI18n();

  return (
    <ThemeProvider>
      <ErrorBoundary
        fallback={
          <Fallback
            title="Ой, что-то пошло не так..."
            description="Попробуйте обновить страницу"
            buttonText="Обновить страницу"
          />
        }>
        <RecoilRoot>
          <SavedProjectConfigurationsListPage data={data} />
        </RecoilRoot>
      </ErrorBoundary>
    </ThemeProvider>
  );
};
